"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorByIndex = exports.getColoredChoices = void 0;
const color_1 = require("@smartsuite/react-ui/lib/constants/color");
const types_1 = require("@smartsuite/types");
function getColoredChoices(choices) {
    if (!choices) {
        return [];
    }
    return choices.map((choice, index) => {
        const color = choice.value_color
            ? {
                background: choice.value_color,
                font: (0, color_1.getTextColor)(choice.value_color),
            }
            : getColorByIndex(index);
        return { ...choice, color };
    });
}
exports.getColoredChoices = getColoredChoices;
function getColorByIndex(index) {
    return types_1.colorsFontsMap[index % types_1.colorsFontsMap.length];
}
exports.getColorByIndex = getColorByIndex;
